import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-4"
}
const _hoisted_2 = { class: "form-section" }
const _hoisted_3 = { class: "form-section-title" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  for: "wl-name",
  class: "form-label required"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_8 = { class: "form-section" }
const _hoisted_9 = { class: "form-section-title" }
const _hoisted_10 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = { class: "form-section-title" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-12 mb-3" }
const _hoisted_16 = {
  for: "wl-street",
  class: "form-label"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-4 mb-3" }
const _hoisted_20 = {
  for: "wl-city",
  class: "form-label"
}
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "col-md-4 mb-3" }
const _hoisted_23 = {
  for: "wl-postal",
  class: "form-label"
}
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { class: "col-md-4 mb-3" }
const _hoisted_26 = {
  for: "wl-country",
  class: "form-label"
}
const _hoisted_27 = { value: null }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_33 = {
  key: 1,
  class: "bi bi-geo-alt-fill me-2"
}
const _hoisted_34 = {
  key: 0,
  class: "alert alert-danger alert-sm mt-2 mb-0"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6 mb-3" }
const _hoisted_37 = {
  for: "wl-lat",
  class: "form-label"
}
const _hoisted_38 = { class: "col-md-6 mb-3" }
const _hoisted_39 = {
  for: "wl-lng",
  class: "form-label"
}
const _hoisted_40 = { class: "form-section" }
const _hoisted_41 = { class: "form-section-title" }
const _hoisted_42 = {
  key: 0,
  class: "d-flex align-items-center gap-2 text-muted"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "asset-select-wrapper position-relative" }
const _hoisted_45 = { class: "input-group" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = {
  key: 0,
  class: "asset-dropdown-results"
}
const _hoisted_48 = {
  key: 0,
  class: "dropdown-item text-muted"
}
const _hoisted_49 = ["onMousedown"]
const _hoisted_50 = { class: "asset-name" }
const _hoisted_51 = {
  key: 0,
  class: "text-muted ms-2"
}
const _hoisted_52 = {
  key: 1,
  class: "badge bg-warning text-dark ms-2"
}
const _hoisted_53 = {
  key: 0,
  class: "selected-assets-list mt-3"
}
const _hoisted_54 = { class: "form-label text-muted small mb-2" }
const _hoisted_55 = { class: "selected-assets-grid" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 1,
  class: "text-muted small mt-2"
}
const _hoisted_58 = { class: "d-flex justify-content-between w-100" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modalRef",
    nested: false,
    size: "lg"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.wirepasLocations.modal.editTitle') : _ctx.$t('components.wirepasLocations.modal.createTitle')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, [
              _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.basicInfo')), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.name')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "wl-name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.nameError }]),
                placeholder: _ctx.$t('components.assetGroups.modal.placeholders.name')
              }, null, 10, _hoisted_6), [
                [_vModelText, _ctx.form.name]
              ]),
              (_ctx.nameError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.nameError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h5", _hoisted_9, [
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-tag me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasLocations.columns.type')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationTypeOptions, (label, key) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: key,
                  type: "button",
                  class: _normalizeClass(["wirepas-type-btn", { 'wirepas-type-btn--active': _ctx.form.locationType === key, [`wirepas-type-btn--${key}`]: true }]),
                  onClick: ($event: any) => (_ctx.form.locationType = _ctx.form.locationType === key ? null : key)
                }, _toDisplayString(label), 11, _hoisted_11))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, [
              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-geo-alt me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.location')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.street')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "wl-street",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.street) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.street')
                }, null, 8, _hoisted_17), [
                  [_vModelText, _ctx.form.street]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.city')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "wl-city",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.city) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.city')
                }, null, 8, _hoisted_21), [
                  [_vModelText, _ctx.form.city]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.postalCode')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "wl-postal",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.postalCode) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.postalCode')
                }, null, 8, _hoisted_24), [
                  [_vModelText, _ctx.form.postalCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.country')), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "wl-country",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.country) = $event)),
                  class: "form-select"
                }, [
                  _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('components.assetGroups.modal.selectCountry')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (countryName, countryKey) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: countryKey,
                      value: countryKey
                    }, _toDisplayString(countryName), 9, _hoisted_28))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.form.country]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary btn-sm",
                  disabled: _ctx.loadingGeocode || !_ctx.form.street || !_ctx.form.city,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleGeocode && _ctx.handleGeocode(...args)))
                }, [
                  (_ctx.loadingGeocode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                    : (_openBlock(), _createElementBlock("i", _hoisted_33)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.geocodeButton')), 1)
                ], 8, _hoisted_31),
                (_ctx.geocodeError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.geocodeError), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.latitude')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "wl-lat",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.lat) = $event)),
                  type: "number",
                  step: "0.000001",
                  class: "form-control",
                  min: "-90",
                  max: "90"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.lat,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.longitude')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "wl-lng",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.lng) = $event)),
                  type: "number",
                  step: "0.000001",
                  class: "form-control",
                  min: "-180",
                  max: "180"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.lng,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h5", _hoisted_41, [
              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-broadcast-pin me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasLocations.detail.gateways')), 1)
            ]),
            (_ctx.gatewaysLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasLocations.loading')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "input-group-text" }, [
                        _createElementVNode("i", { class: "bi bi-broadcast-pin" })
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        ref: "gwSearchInputRef",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gwSearch) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: _ctx.$t('components.wirepasLocations.modal.gatewaySearch'),
                        autocomplete: "off",
                        onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showGwDropdown = true)),
                        onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onGwBlur && _ctx.onGwBlur(...args)))
                      }, null, 40, _hoisted_46), [
                        [_vModelText, _ctx.gwSearch]
                      ]),
                      (_ctx.gwSearch)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-secondary",
                            onMousedown: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.gwSearch = ''), ["prevent"]))
                          }, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                          ]))], 32))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary",
                        onMousedown: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.showGwDropdown = !_ctx.showGwDropdown), ["prevent"]))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["bi", _ctx.showGwDropdown ? 'bi-chevron-up' : 'bi-chevron-down'])
                        }, null, 2)
                      ], 32)
                    ]),
                    (_ctx.showGwDropdown)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          (!_ctx.filteredGateways.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.gwSearch ? _ctx.$t('components.wirepasLocations.modal.noGatewaysFound') : _ctx.$t('components.wirepasLocations.modal.noGateways')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGateways, (gw) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: gw.gwId,
                              class: "dropdown-item asset-dropdown-item",
                              onMousedown: _withModifiers(($event: any) => (_ctx.addGateway(gw)), ["prevent"])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["wirepas-status-dot me-2", gw.state === 'online' ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                              }, null, 2),
                              _cache[26] || (_cache[26] = _createElementVNode("i", { class: "bi bi-plus-circle me-2 text-success" }, null, -1)),
                              _createElementVNode("span", _hoisted_50, _toDisplayString(gw.gwId), 1),
                              (gw.gatewayModel)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_51, "(" + _toDisplayString(gw.gatewayModel) + ")", 1))
                                : _createCommentVNode("", true),
                              (gw.assignedLocationId && gw.assignedLocationId !== _ctx.currentLocationId)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('components.wirepasLocations.modal.assignedElsewhere')), 1))
                                : _createCommentVNode("", true)
                            ], 40, _hoisted_49))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.selectedGateways.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.gateways')) + " (" + _toDisplayString(_ctx.selectedGateways.length) + ") ", 1),
                        _createElementVNode("div", _hoisted_55, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGateways, (gw) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: gw.gwId,
                              class: "selected-asset-badge"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["wirepas-status-dot", gw.state === 'online' ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                              }, null, 2),
                              _createElementVNode("span", null, _toDisplayString(gw.gwId), 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-remove",
                                onClick: ($event: any) => (_ctx.removeGateway(gw.gwId))
                              }, [...(_cache[27] || (_cache[27] = [
                                _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                              ]))], 8, _hoisted_56)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (!_ctx.gatewaysLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.$t('components.wirepasLocations.modal.noGatewaysSelected')), 1))
                      : _createCommentVNode("", true)
                ]))
          ])
        ], 32)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.close')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          disabled: _ctx.loading,
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_60))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.isEditMode ? _ctx.$t('components.assetGroups.modal.update') : _ctx.$t('components.assetGroups.modal.create')), 1)
        ], 8, _hoisted_59)
      ])
    ]),
    _: 1
  }, 512))
}